import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MdMenu } from 'react-icons/md';
import AdminSidebar from '../components/admin/Sidebar';
import { PanelToastProvider } from '../context/PanelToastContext';
import { GymSettingsProvider, useGymSettings } from '../context/GymSettingsContext';
import { useAuth } from '../context/AuthContext';
import { warmPanelData } from '../services/panelBootstrap';
import { setActiveGymId } from '../services/receptionist/gymContext';
import { setPanelDataScope } from '../services/gym/branchContext';
import OfflineStatusBanner from '../components/shared/OfflineStatusBanner';
import '../layouts/OwnerLayout.css';
import '../styles/panelShared.css';

function AdminShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { account } = useAuth();
  const { gym } = useGymSettings();

  useEffect(() => {
    setPanelDataScope('admin');
    return () => setPanelDataScope('');
  }, []);

  useEffect(() => {
    if (!account?.gym_id) return;
    setActiveGymId(account.gym_id);
    warmPanelData(account.gym_id, { role: 'admin' });
  }, [account?.gym_id]);

  return (
    <div className="owner-layout">
      <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="owner-main">
        <OfflineStatusBanner />
        <header className="owner-topbar">
          <button
            type="button"
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <MdMenu />
          </button>
          <span className="owner-topbar-label">
            Gym Admin Panel
            {gym?.name ? ` · ${gym.name}` : ''}
          </span>
        </header>
        <main className="owner-content">
          <Outlet key={account?.gym_id || 'admin'} />
        </main>
      </div>
    </div>
  );
}

function AdminLayout() {
  return (
    <PanelToastProvider>
      <GymSettingsProvider>
        <AdminShell />
      </GymSettingsProvider>
    </PanelToastProvider>
  );
}

export default AdminLayout;
